import React, { useState } from "react";
import styles from "./passwordmanagment.module.css";

import { InputField, SubmitButton, TextComponent } from "../../../components";
import Password from "antd/es/input/Password";
import { VscEye } from "react-icons/vsc";
import { TbEyeClosed } from "react-icons/tb";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import ModalComponent from "../../../components/modal/ModalComponent";
import { useNavigate } from "react-router-dom";

const Passwordmanagment = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirnPassword, setConfirnPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [NpasswordVisible, setNPasswordVisible] = useState(false);
  const [CpasswordVisible, setCPasswordVisible] = useState(false);
  const [Modal, setModal] = useState(false);
  const navigate = useNavigate();

  return (
    <div className={styles.AccountContent}>
      {/* <HeadingComponent text={"Change Password"} fontSize={20} /> */}
      <TextComponent text={"Change Password"} className={styles.HeadText} />

      <InputField
        label={"Current Password"}
        style={{ marginTop: "30px" }}
        placeholder={"●●●●●●●●●●"}
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        rightIcon={
          passwordVisible ? (
            <VscEye size={20} color={"var(--input-icon)"} />
          ) : (
            <TbEyeClosed size={20} color={"var(--input-icon)"} />
          )
        }
        onRightIconPress={() => setPasswordVisible(!passwordVisible)}
        type={passwordVisible ? "text" : "password"}
      />

      <InputField
        label={"New Password"}
        style={{ marginTop: "30px" }}
        placeholder={"●●●●●●●●●●"}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        rightIcon={
          NpasswordVisible ? (
            <VscEye size={20} color={"var(--input-icon)"} />
          ) : (
            <TbEyeClosed size={20} color={"var(--input-icon)"} />
          )
        }
        onRightIconPress={() => setNPasswordVisible(!NpasswordVisible)}
        type={NpasswordVisible ? "text" : "password"}
      />
      <InputField
        label={"Confirm New Password"}
        style={{ marginTop: "30px" }}
        placeholder={"●●●●●●●●●●"}
        value={confirnPassword}
        onChange={(e) => setConfirnPassword(e.target.value)}
        rightIcon={
          CpasswordVisible ? (
            <VscEye size={20} color={"var(--input-icon)"} />
          ) : (
            <TbEyeClosed size={20} color={"var(--input-icon)"} />
          )
        }
        onRightIconPress={() => setCPasswordVisible(!CpasswordVisible)}
        type={CpasswordVisible ? "text" : "password"}
      />

      <SubmitButton
        title={"Update Password"}
        primary
        style={{ width: "70%", marginTop: "30px" }}
        onClick={()=> setModal(true)}
      />




           <ModalComponent
        open={Modal}
        onClickOkButton={() => {
          setModal(false);
        }}
        onClickCancelButton={() => setModal(false)}
        onCancel={() => setModal(false)}
        className={styles.modalCont}
        title={"Password changed Successfully "}
        headingClass={styles.modalHeading}
        width={"400px"}
        buttonTitle={"OK"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
    
        onBtnPress={() => {
          navigate(-1);
          setModal(false);
        }}
      >
        {/* <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div> */}
      </ModalComponent>
    </div>
  );
};

export default Passwordmanagment;
